export default function authHeader() {
  const token = sessionStorage.getItem("token");
  // console.log("token: ", token);
  const header = {
    "x-api-key": process.env.REACT_APP_JOB_X_API_KEY,
  };

  if (token) {
    header["Authorization"] = "Bearer " + token;
  }

  return { headers: header };
}
